<app-link
    class="mfr-card gtm-resource-more-from-resource"
    [appRouterLink]="learningObject.routerLink"
    attr.aria-label="Open resource {{ learningObject.title }}"
>
    <div class="thumbnail">
        <app-resource-card-poster
            [posterImage]="learningObject.getPosterImage(269, 151)"
            [duration]="learningObject.duration"
            [gtmPrefix]="gtmPrefix"
            [title]="learningObject.linkTitle"
            [absoluteUrl]="learningObject.canonicalUrl"
        >
        </app-resource-card-poster>
    </div>
    <div class="content">
        <app-card-title [height]="62">{{ learningObject.title }}</app-card-title>
        <app-card-content-project-name
            *ngIf="learningObject.project && learningObject.project.title"
            [text]="learningObject.project.title | safeTruncate: 21"
        ></app-card-content-project-name>
        <app-mfr-card-meta
            [mediaType]="learningObject.mediaType[0]"
            [supportMaterialsCount]="learningObject.supportMaterials.length"
            [supportMaterialsLink]="learningObject.routerLink"
            [ngClass]="{ 'video-type': learningObject.mediaType[0] === 'Video' }"
        >
        </app-mfr-card-meta>
    </div>
</app-link>
